/**
 * Shared default page size for paginated lists (OperationsList,
 * MatchLogs, Shop). Collocated with the `Pagination` UI component
 * because every consumer already imports `Pagination` — no new alias.
 */
export const DEFAULT_PAGE_SIZE = 10
